<script setup lang="ts">
defineProps<{
    totalCost: string;
    totalItems: number;
    totalTokens: string;
}>();
</script>

<template>
    <div class="grid grid-cols-1 gap-4 md:grid-cols-3">
        <div class="rounded-2xl border border-[#E5E7EB] bg-white p-5 shadow-sm">
            <p class="text-xs font-semibold uppercase tracking-wider text-[#626468]">
                {{ $t('aura.processingCosts.summary.totalCost') }}
            </p>
            <p class="mt-2 text-2xl font-bold text-[#242B59]">{{ totalCost }}</p>
        </div>
        <div class="rounded-2xl border border-[#E5E7EB] bg-white p-5 shadow-sm">
            <p class="text-xs font-semibold uppercase tracking-wider text-[#626468]">
                {{ $t('aura.processingCosts.summary.totalItems') }}
            </p>
            <p class="mt-2 text-2xl font-bold text-[#242B59]">{{ totalItems }}</p>
        </div>
        <div class="rounded-2xl border border-[#E5E7EB] bg-white p-5 shadow-sm">
            <p class="text-xs font-semibold uppercase tracking-wider text-[#626468]">
                {{ $t('aura.processingCosts.summary.totalTokens') }}
            </p>
            <p class="mt-2 text-2xl font-bold text-[#242B59]">{{ totalTokens }}</p>
        </div>
    </div>
</template>
